import React from 'react';
import PropTypes from 'prop-types';

import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDProgress from 'components/MDProgress';
import { formatStringToNumber } from 'helpers/formatData';
import { formatPercentages } from 'helpers/formatData';

const ProgressStatus = ({ value }) => {
  let val = value;
  if (value < 0) {
    val = 0;
  } else if (value > 100) {
    val = 100;
  }
  
  let color;
  if (value <= 20) {
    color = 'error';
  } else if (value <= 80) {
    color = 'info';
  } else color = 'success';

  return (
    <MDBox alignItems="center" sx={{maxWidth: '9rem', overflow: 'hidden'}}>
      <MDTypography
        variant="caption"
        color="text"
        fontSize="xs"
        fontWeight="medium"
      >
        {formatPercentages(value)}
      </MDTypography>
      <MDBox ml={0.5} width="9rem">
        <MDProgress
          variant="gradient"
          color={color}
          value={formatStringToNumber(val)}
        />
      </MDBox>
    </MDBox>
  );
};

ProgressStatus.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

ProgressStatus.defaultProps = {
  value: 0,
};

export default ProgressStatus;
